import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "b2r_session";
api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join(", ");
  return d || "Something went wrong. Please try again.";
};

export const FIELD =
  "h-12 rounded-xl bg-black/50 border-white/20 text-base text-white placeholder:text-white/35 focus-visible:ring-[#D4AF37] focus-visible:border-[#D4AF37]";
export const AREA =
  "rounded-xl bg-black/50 border-white/20 text-base text-white placeholder:text-white/35 focus-visible:ring-[#D4AF37] min-h-[120px]";

export const fmtMoney = (n) => `$${Number(n).toFixed(2).replace(/\.00$/, "")}`;

export const fmtDate = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" });

export const fmtTime = (t) => {
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
};
